import api from "./api";

// Task Category service (CRUD)
// GET    /task-category
// GET    /task-category/:id
// POST   /task-category
// PATCH  /task-category/:id
// DELETE /task-category/:id

export async function getTaskCategories() {
  const res = await api.get("/task-category");
  return Array.isArray(res) ? res : [];
}

export async function getTaskCategoryById(categoryId) {
  if (categoryId === undefined || categoryId === null || categoryId === "") {
    throw new Error("categoryId is required");
  }
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  return api.get(`/task-category/${idNum}`);
}

export async function createTaskCategory(payload) {
  return api.post("/task-category", payload || {});
}

export async function updateTaskCategory(categoryId, payload) {
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  const body = { ...(payload || {}) };
  delete body.id;
  return api.patch(`/task-category/${idNum}`, body);
}

export async function deleteTaskCategory(categoryId) {
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  return api.delete(`/task-category/${idNum}`);
}
